
const paramsKey = 'public-param'

export function getPublicParams() {
  // console.log("localStorage-getPublicParams");
  return JSON.parse(localStorage.getItem(paramsKey))
}

export function setPublicParams(paramsObj) {
  // console.log("localStorage-setPublicParams");
  return localStorage.setItem(paramsKey, JSON.stringify(paramsObj || {}))
}

export function removePublicParams() {
  return localStorage.removeItem(paramsKey)
}




